module.exports = __webpack_public_path__ + "img/ipad-jp-3.a3c5d6e.jpg";